import React from 'react';
import { Alert } from 'react-bootstrap';

const NoCandidatesAlert = () => {
  return (
    <Alert variant="warning" className="mb-3 px-3 py-2 fs-10">
      No SharedLiving-eligible staff at this facility - onboard a replacement
      before deactivating.
    </Alert>
  );
};

export default NoCandidatesAlert;
